/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CrateColor } from './CrateColor';
import {
    CrateColorFromJSON,
    CrateColorFromJSONTyped,
    CrateColorToJSON,
    CrateColorToJSONTyped,
} from './CrateColor';
import type { LootBoxPlacementContext } from './LootBoxPlacementContext';
import {
    LootBoxPlacementContextFromJSON,
    LootBoxPlacementContextFromJSONTyped,
    LootBoxPlacementContextToJSON,
    LootBoxPlacementContextToJSONTyped,
} from './LootBoxPlacementContext';
import type { LootBoxCycleType } from './LootBoxCycleType';
import {
    LootBoxCycleTypeFromJSON,
    LootBoxCycleTypeFromJSONTyped,
    LootBoxCycleTypeToJSON,
    LootBoxCycleTypeToJSONTyped,
} from './LootBoxCycleType';

/**
 * 
 * @export
 * @interface UpdateLootBoxConfigBody
 */
export interface UpdateLootBoxConfigBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateLootBoxConfigBody
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLootBoxConfigBody
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLootBoxConfigBody
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLootBoxConfigBody
     */
    redemptionAnimation?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLootBoxConfigBody
     */
    transitionEffectEnabled?: boolean;
    /**
     * 
     * @type {LootBoxCycleType}
     * @memberof UpdateLootBoxConfigBody
     */
    cycleType?: LootBoxCycleType;
    /**
     * 
     * @type {Date}
     * @memberof UpdateLootBoxConfigBody
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateLootBoxConfigBody
     */
    endDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof UpdateLootBoxConfigBody
     */
    maxOpensPerUser?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLootBoxConfigBody
     */
    maxOpensPerUserPerCycle?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLootBoxConfigBody
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLootBoxConfigBody
     */
    fuelPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLootBoxConfigBody
     */
    minPurchaseQuantity?: number;
    /**
     * 
     * @type {Array<LootBoxPlacementContext>}
     * @memberof UpdateLootBoxConfigBody
     */
    placementContexts?: Array<LootBoxPlacementContext>;
    /**
     * 
     * @type {number}
     * @memberof UpdateLootBoxConfigBody
     */
    sortPriority?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLootBoxConfigBody
     */
    isActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLootBoxConfigBody
     */
    onChain?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateLootBoxConfigBody
     */
    nftTracker?: string;
    /**
     * 
     * @type {CrateColor}
     * @memberof UpdateLootBoxConfigBody
     */
    crateColor?: CrateColor;
}



/**
 * Check if a given object implements the UpdateLootBoxConfigBody interface.
 */
export function instanceOfUpdateLootBoxConfigBody(value: object): value is UpdateLootBoxConfigBody {
    return true;
}

export function UpdateLootBoxConfigBodyFromJSON(json: any): UpdateLootBoxConfigBody {
    return UpdateLootBoxConfigBodyFromJSONTyped(json, false);
}

export function UpdateLootBoxConfigBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLootBoxConfigBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'image': json['image'] == null ? undefined : json['image'],
        'redemptionAnimation': json['redemptionAnimation'] == null ? undefined : json['redemptionAnimation'],
        'transitionEffectEnabled': json['transitionEffectEnabled'] == null ? undefined : json['transitionEffectEnabled'],
        'cycleType': json['cycleType'] == null ? undefined : LootBoxCycleTypeFromJSON(json['cycleType']),
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'maxOpensPerUser': json['maxOpensPerUser'] == null ? undefined : json['maxOpensPerUser'],
        'maxOpensPerUserPerCycle': json['maxOpensPerUserPerCycle'] == null ? undefined : json['maxOpensPerUserPerCycle'],
        'price': json['price'] == null ? undefined : json['price'],
        'fuelPrice': json['fuelPrice'] == null ? undefined : json['fuelPrice'],
        'minPurchaseQuantity': json['minPurchaseQuantity'] == null ? undefined : json['minPurchaseQuantity'],
        'placementContexts': json['placementContexts'] == null ? undefined : ((json['placementContexts'] as Array<any>).map(LootBoxPlacementContextFromJSON)),
        'sortPriority': json['sortPriority'] == null ? undefined : json['sortPriority'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'onChain': json['onChain'] == null ? undefined : json['onChain'],
        'nftTracker': json['nftTracker'] == null ? undefined : json['nftTracker'],
        'crateColor': json['crateColor'] == null ? undefined : CrateColorFromJSON(json['crateColor']),
    };
}

export function UpdateLootBoxConfigBodyToJSON(json: any): UpdateLootBoxConfigBody {
    return UpdateLootBoxConfigBodyToJSONTyped(json, false);
}

export function UpdateLootBoxConfigBodyToJSONTyped(value?: UpdateLootBoxConfigBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'image': value['image'],
        'redemptionAnimation': value['redemptionAnimation'],
        'transitionEffectEnabled': value['transitionEffectEnabled'],
        'cycleType': LootBoxCycleTypeToJSON(value['cycleType']),
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
        'maxOpensPerUser': value['maxOpensPerUser'],
        'maxOpensPerUserPerCycle': value['maxOpensPerUserPerCycle'],
        'price': value['price'],
        'fuelPrice': value['fuelPrice'],
        'minPurchaseQuantity': value['minPurchaseQuantity'],
        'placementContexts': value['placementContexts'] == null ? undefined : ((value['placementContexts'] as Array<any>).map(LootBoxPlacementContextToJSON)),
        'sortPriority': value['sortPriority'],
        'isActive': value['isActive'],
        'onChain': value['onChain'],
        'nftTracker': value['nftTracker'],
        'crateColor': CrateColorToJSON(value['crateColor']),
    };
}

